module.exports = __webpack_public_path__ + "static/slide-two-ec31561ae7f790750027d9ffba357b38.png";